/* Armazém 11/2026 — bolinhas de stories: anel laranja = não visto. Lê/grava localStorage.reels_seen
   (o feed de vídeos também grava ao tocar cada vídeo). Vistos vão pro fim da fila, como no Instagram. */
(function () {
  if (window.__storiesBar) return;
  window.__storiesBar = true;
  function seen() {
    try {
      var o = JSON.parse(localStorage.getItem('reels_seen'));
      return o && typeof o === 'object' ? o : {};
    } catch (e) {
      return {};
    }
  }
  function paint() {
    var s = seen();
    document.querySelectorAll('.stories-bar__row').forEach(function (row) {
      var vistos = [];
      row.querySelectorAll('.stories-bar__item[data-reel]').forEach(function (a) {
        var v = !!s[a.dataset.reel];
        a.classList.toggle('is-seen', v);
        if (v) vistos.push(a);
      });
      vistos.forEach(function (a) { row.appendChild(a); });
    });
  }
  paint();
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.stories-bar__item[data-reel]');
    if (!a) return;
    try {
      var s = seen();
      s[a.dataset.reel] = 1;
      localStorage.setItem('reels_seen', JSON.stringify(s));
    } catch (err) {}
    a.classList.add('is-seen');
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) paint(); });
})();
